





















import Vue from 'vue';
import { ILimitingPosition } from '@/common/interfaces/limiting.interface';
import config from '../../../config';

interface ILimitingPositionDisplayComponent {
  closeToOpenThreshold: number;
}

export default Vue.extend({
  data(): ILimitingPositionDisplayComponent {
    return {
      closeToOpenThreshold: config.bouncer.config.closeToOpenThreshold,
    };
  },
  props: {
    loading: {
      default: false,
      type: Boolean,
    },
    mode: {
      default: `light`,
      type: String,
    },
    order: {
      default: `column`,
      type: String,
    },
    position: {
      required: true,
      type: Object as () => ILimitingPosition,
    },
    size: {
      default: `sm`,
      type: String,
    },
  },
});
